import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ApiError, api } from '../../lib/api'

export default function Contact() {
  const location = useLocation()
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await api('/contact/request-demo', {
        method: 'POST',
        body: JSON.stringify({
          practice_or_organization_name: name,
          email,
          message,
          source_page: location.pathname,
        }),
      })
      setSubmitted(true)
    } catch (err) {
      setError(err instanceof ApiError ? (err.message || 'Could not send your request. Try again.') : 'Something went wrong. Try again.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <section className="section light" style={{ minHeight: '70vh' }}>
      <h2>Let's talk</h2>
      <p className="lead muted">
        Solo providers, group practices, and clinics can <Link to="/signup/practice">set up an account directly</Link> —
        no waiting required. If you're a larger organization or want to talk through a custom setup first,
        tell us a bit about your practice and a member of our team will follow up.
      </p>
      {submitted ? (
        <div className="card" style={{ maxWidth: 420, marginTop: 18 }}>
          <h3>Thanks — we'll be in touch.</h3>
          <p>A member of the ATUUNE team will reach out soon.</p>
        </div>
      ) : (
        <form className="card" style={{ maxWidth: 420, marginTop: 18 }} onSubmit={submit}>
          <div className="field"><label>Practice / organization name</label><input className="inp" value={name} onChange={(e) => setName(e.target.value)} required /></div>
          <div className="field"><label>Your email</label><input className="inp" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></div>
          <div className="field"><label>What would you like to talk through?</label><input className="inp" value={message} onChange={(e) => setMessage(e.target.value)} required /></div>
          {error && <div className="form-error" role="alert">{error}</div>}
          <button className="btn full" type="submit" disabled={busy}>{busy ? 'Sending…' : 'Request a conversation'}</button>
        </form>
      )}
    </section>
  )
}
